import axios from 'axios'
import store from '@/store' // 引入 Vuex（用于获取 Token）
import router from '@/router' // 引入路由（用于跳转登录页）

// 创建 Axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 基础接口地址（从环境变量获取）
  timeout: 15000
})

// 请求拦截器（请求发送前执行）
service.interceptors.request.use(
  (config) => {
    const token = store.state.userInfo.token || localStorage.getItem('token')
    if (token) {
      config.headers.token = token // 格式按后端要求调整
    }

    // 3. 统一添加固定参数（如版本号、设备信息）
    if (config.method === 'get') {
      config.params = { ...config.params }
    } else {
      config.data = { ...config.data }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器（收到响应后执行）
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code !== 1) { // 非成功状态码
      if (res.code === 401) {
        router.push('/login')
      }
    }
    return res
  },
  (error) => {
    return Promise.resolve({ code: 0 })
  }
)

export default service // 导出配置好的 Axios 实例
